<template>
    <div>
        <card>
            <h2 style="color:#00467f;margin-top:10px;margin-left:5px;font-weight:bold;text-align:left">ANTIRICICLAGGIO - CARICA FILE</h2>
            <div class="form-row justify-content-center">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica visura</h3>
                    <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
                </div>
            </div>
           
            <div class="row justify-content-start" style="margin-top:10px;">
                <div class="col">
                <div v-if="cliente[0].ANTIRIC_CLIENTE_META.length > 0" style="margin-top:15px">
                    <p>File caricati:</p>
                    <div v-for="value in cliente[0].ANTIRIC_CLIENTE_META" v-bind:key="value.ID">
                        <p><a :href="'https://sviluppoallergeni.confcom.it'+  value.VALUE.url  + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                    </div>
                </div>
                <div v-else></div>
                </div>
                <div class="col"></div>
                <div class="col"></div>
            </div>
            <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaValori()">Salva</button>
        </card>
        
        <!--  MODAL CARICARE FILE -->
        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import Services from '@/services/Services';
import AntiriciclaggioServices from '@/services/AntiriciclaggioServices';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false
            },
            file: null,
            showCheckFile: false,
            showLoader: false,
            cliente: null,

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            
            idCliente: null,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        checkFileUpload: function() {
            this.showCheckFile = true;
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            await AntiriciclaggioServices.caricaDocumentoCliente(this.idCliente, formData)
            .then(response => { risposta = response.data})
            .catch( function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await Services.refreshTokenFunction();
                if (value) { await this.handleFileUpload(); }
            }
            this.showCheckFile = false;
            this.showLoader = false;
            await this.caricaCliente(this.idCliente);
        }, 

        caricaCliente: async function(id) {
            let errore = 0;
            await AntiriciclaggioServices.getCliente(id)
            .then(response => { this.cliente= response.data})
            .catch( function (error) {
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            });
            if (errore == 401) {
                let value = await Services.refreshTokenFunction();
                if (value) { await this.caricaCliente(id); }
            }
            console.log(`cliente:`);
            console.log(this.cliente);
            this.idCliente = this.cliente[0].ID;
            console.log(this.cliente[0].ANTIRIC_CLIENTE_META[0]);
            console.log(this.cliente[0].ANTIRIC_CLIENTE_META[0].VALUE);
        },

        handleremoveFile: function(){
            this.file = null;
        },


        salvaValori: async function() {
            this.$router.push({
                path: '/clienti'
            })
            
        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idCliente = this.$route.query.idCliente;
            console.log(`idCliente=${this.idCliente}.`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                if (this.idCliente != null)
                    await this.caricaCliente(this.idCliente);
            } catch (error) {
                console.log(`error try/catch = ${error}`);
                if (error.response.status == 401) {
                await Services.refreshTokenFunction();
                }
            }
        }
    },

    mounted() {
        
    },
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}
label {
    font-size: 18px;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

</style>
  